import { defineStore } from "pinia";

import { useBundleStore } from "@/stores/modules/bundle";
import { useWebproductStore } from "@/stores/modules/webproduct";

export const useConfigStore = defineStore("config", {
  state: () => ({
    pageAttributesInPageOptions: 0,
    matrixComplete: false,
    showUpload: false,
    personalizationFullPage: true,
    addToCartFullPage: false,
    disableDeleteUploadAfterConnect: false,
    listenScroll: false
  }),

  getters: {
    getListenScroll(state) {
      return state.listenScroll;
    },
    getDisableDeleteUploadAfterConnect(state) {
      return state.disableDeleteUploadAfterConnect;
    },
    getPageAttributesInPageOptions(state) {
      return state.pageAttributesInPageOptions;
    },
    getMatrixComplete(state) {
      return state.matrixComplete;
    },
    getShowUpload(state) {
      return state.showUpload;
    },
    getPersonalizationFullPage(state) {
      return state.personalizationFullPage;
    },
    getAddToCartFullPage(state) {
      const bundleStore = useBundleStore();
      if (bundleStore.getBundleIsActive) {
        return bundleStore.getBundleShowAddToCart;
      }
      return state.addToCartFullPage;
    }
  },

  actions: {
    setListenScroll(payload) {
      this.listenScroll = payload;
      const that = this;
      setTimeout(() => {
        that.onScrollEventPosition();
      }, 1000);
    },
    setMatrixComplete(payload) {
      this.matrixComplete = payload;
      this.setShowUpload(payload);
    },
    setShowUpload(payload) {
      this.showUpload = payload;
    },
    setPersonalizationFullPage(payload) {
      this.personalizationFullPage = payload;
    },
    setAddToCartFullPage(payload) {
      this.addToCartFullPage = payload;
    },
    setDisableDeleteUploadAfterConnect(payload) {
      this.disableDeleteUploadAfterConnect = payload;
    },
    onScrollEvent(payload) {
      if (!this.getListenScroll) {
        return;
      }
      this.onScrollEventPosition();
    },
    onScrollEventPosition() {
      const webproductStore = useWebproductStore();
      if (webproductStore.getIsMobile) {
        jQuery(
          "#" + webproductStore.getSelector + " .matrix_loading_circle"
        ).css("top", "30%");
        return;
      }

      const bounding = document
        .getElementById(webproductStore.getSelector)
        .getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      let top = viewportHeight - bounding.top;
      if (bounding.top < 0) {
        if (bounding.bottom > viewportHeight) {
          // element is full inside the viewport, so add the element in the middle
          top = -1 * bounding.top + viewportHeight / 2;
        } else {
          let offset = bounding.bottom / 2;
          top = -1 * bounding.top + offset;
        }
      } else {
        if (bounding.bottom > viewportHeight) {
          let offset = (viewportHeight - bounding.top) / 2;
          top = offset;
        } else {
          top = bounding.height / 2;
        }
      }

      top -= 50;

      jQuery("#" + webproductStore.getSelector + " .matrix_loading_circle").css(
        "top",
        top + "px"
      );
    }
  }
});
